export const SET_MUSICPLAYER_TRACK = 'SET_MUSICPLAYER_TRACK';
export const STOP_MUSIC = 'STOP_MUSIC';
export const PAUSE_MUSIC = 'PAUSE_MUSIC';

export const setMusicPlayerTrack = (track) => ({
  type: SET_MUSICPLAYER_TRACK,
  payload: track,
});

export const stopMusic = () => ({
  type: STOP_MUSIC,
});

export const pauseMusic = () => ({
  type: PAUSE_MUSIC,
});


// export const SET_MUSICPLAYER_TRACK = 'SET_MUSICPLAYER_TRACK';
// export const STOP_MUSIC = 'STOP_MUSIC';
// export const setMusicPlayerTrack = (track) => ({
//   type: SET_MUSICPLAYER_TRACK,
//   payload: track,
// });

// export const stopMusic = () => ({
//   type: STOP_MUSIC,
// });
